const state = {
  sidebarIsOpen: true,
  testShapes: [], // test shapes for view mode
  currentImage: '', // test shapes for view mode
  testSeats: [],
  currentSeatImage: '',
}

export default state;